import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { BATCH_ACTION_TYPES } from '../../enums/AssetBatchActionTypes';

class AssetActions extends React.PureComponent {
    onBatchAction = actionType => {
        const { openBatchActionModal, selectedAssetsIds, assets } = this.props;

        // Don't proceed if no items selected
        if (selectedAssetsIds.size === 0) {
            return;
        }

        // convert selectedAssetsIds Set to an array
        const selectedAssetsIdsArray = [...selectedAssetsIds];

        const selectedAssets = selectedAssetsIdsArray
            .map(id => {
                const asset = assets.find(a => a && a.id === id);
                return asset || null;
            })
            .filter(asset => asset !== null);

        openBatchActionModal(actionType, selectedAssets);
    };

    getIconForAction = (action) => {
        switch (action) {
            case BATCH_ACTION_TYPES.DUPLICATE:
                return 'content_copy';
            case BATCH_ACTION_TYPES.MOVE_TO:
                return 'drive_file_move';
            case BATCH_ACTION_TYPES.COPY_TO:
                return 'file_copy';
            case BATCH_ACTION_TYPES.DOWNLOAD:
                return 'download';
            case BATCH_ACTION_TYPES.PUBLISH:
                return 'publish';
            case BATCH_ACTION_TYPES.DELETE:
                return 'delete';
            case BATCH_ACTION_TYPES.TAG:
                return 'local_offer';
            default:
                return '';
        }
    };

    render() {
        const {
            actions,
            assets,
            selectedAssetsIds,
            onSelectAllClick,
            classes,
        } = this.props;

        if (!actions.length || assets.length === 0) {
            return null;
        }

        const hasSelectedItems = selectedAssetsIds.size > 0;
        const allItemsSelected = assets.length > 0 && assets.length === selectedAssetsIds.size;

        const actionsList = actions.map(action => (
            <IconButton
                key={action}
                className={`${classes.actionButton} ${!hasSelectedItems ? classes.disabledButton : ''}`}
                onClick={() => this.onBatchAction(action)}
                title={action}
                disabled={!hasSelectedItems}
            >
                <i className="material-icons">{this.getIconForAction(action)}</i>
            </IconButton>
        ));

        const selectedText = hasSelectedItems ? `(${selectedAssetsIds.size} selected)` : '';

        return (
            <div className={classes.wrapper}>
                <div className={classes.actions}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={allItemsSelected}
                                onChange={onSelectAllClick}
                            />
                        }
                        label="Select all"
                        className={classes.noSelect}
                    />
                    {hasSelectedItems && (
                        <Typography noWrap className={classes.noSelect}>
                            {selectedText}
                        </Typography>
                    )}
                </div>
                <div className={classes.actions}>{actionsList}</div>
            </div>
        );
    }
}

AssetActions.propTypes = {
    assets: PropTypes.array.isRequired,
    actions: PropTypes.array,
    selectedAssetsIds: PropTypes.object.isRequired,
    openBatchActionModal: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
};

AssetActions.defaultProps = {
    actions: [],
};

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        paddingLeft: spacing.unit * 4,
        paddingRight: spacing.unit * 4,
        boxSizing: 'border-box',
        flexWrap: 'wrap',
        marginBottom: 0,
        backgroundColor: 'white',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        padding: spacing.unit * 2,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        borderBottom: '2px solid #e0e0e0',
        minHeight: '64px',
        alignItems: 'center',
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
    },
    noSelect: {
        userSelect: 'none'
    },
    actionButton: {
        backgroundColor: 'white',
        border: '1px solid #e0e0e0',
        margin: '0 4px',
        padding: spacing.unit,
        '&:hover': {
            backgroundColor: '#f5f5f5',
            '& i': {
                color: '#424242',
            }
        },
        '& i': {
            color: '#9e9e9e',
            fontSize: '18px',
        }
    },
    disabledButton: {
        '&:hover': {
            backgroundColor: 'white',
            '& i': {
                color: '#d0d0d0',
            }
        },
        '& i': {
            color: '#d0d0d0',
        },
        cursor: 'not-allowed',
    },
});

export default injectSheet(style)(AssetActions); 



// WEBPACK FOOTER //
// ./src/components/assets/AssetActions.js